import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomCarousel from "../../Components/Carousel";
import styles from "../logs/components/style.module.css";

const InputsSP = [
  { title: "Công thức", key: "CongThuc" },
  { title: "Xuất xứ", key: "XuatXu" },
  { title: "Mã số phân bón", key: "MaSoPhanBon" },
  { title: "Quy cách", key: "QuyCach" },
  { title: "Loại hàng", key: "LoaiHang" },
  { title: "Thành phần", key: "ThanhPhan" },
  { title: "Cách sử dụng", key: "CachSuDung" },
];

export default function CheckContainer() {
  const [data, setData] = useState([]);
  const param = useParams();
  const { proxy } = useSelector((state) => state);
  const [loading, setLoading] = useState(true);

  function formatDate(data, isDate) {
    const date = data ? moment.utc(data).format("DD/MM/YYYY HH:mm:ss") : "";
    if (isDate && date.toString() !== "Invalid date") {
      return { data: date, isUnsetColor: true };
    }
    return { data };
  }

  useEffect(() => {
    fetch(`${proxy()}/api/CheckUrl/${param.epc}`, {
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  }, [param.epc]);

  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: "100%",
          objectFit: "none",
          height: "92vh",
        }}
      >
        <img
          width={"40px"}
          className="mb-1"
          src="/images/icon/load.gif"
          alt="Loading..."
        />
      </div>
    );
  }
  const { SanPham, DonViSanXuat, EPC, message } = data || {};
  return (
    <>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img src="/images/logo/logodpm.png" alt="logo" />
        </div>
      </div>
      <main className={styles.custom_main}>
        <div className={styles.content}>
          {message ? (
            <div className={styles.condition}>{message}</div>
          ) : (
            <>
              <div>
                {SanPham?.HinhAnh?.length > 0 ? (
                  <CustomCarousel imgs={SanPham?.HinhAnh} proxy={proxy} />
                ) : null}
                <div className={styles.title} style={{ color: EPC?.color }}>
                  {/* tem sản phẩm {EPC?.MoTaTrangThai} */}
                </div>
                {/* <div className={styles.title}>thông tin sản phẩm</div> */}
                <div className={styles.title}>{SanPham?.TieuDe}</div>
                {InputsSP.map(({ key, title }) => (
                  <div key={key}>
                    <span style={{ fontWeight: "bold" }}>{title}:</span>{" "}
                    {SanPham?.[key]}
                  </div>
                ))}
              </div>
              <>
                <div id={styles.content1}>
                  {data?.LichSuTruyVet?.length > 0 &&
                    data.LichSuTruyVet.map((item, index) => (
                      <div key={index} className={styles.event}>
                        <div
                          className={styles.title}
                          style={{ color: item?.color }}
                        >
                          {item?.TieuDe}
                        </div>

                        {item?.fields?.map((field, index) => {
                          if (!field) {
                            return null;
                          }
                          const { data, isUnsetColor } = formatDate(
                            field?.value,
                            field?.isDate
                          );
                          return (
                            <div key={index}>
                              <div className={styles.field_title}>
                                {field?.field}:
                                <span
                                  className={`${styles.field_content} ${styles.custom_span}`}
                                  style={{
                                    color: isUnsetColor ? "unset" : "",
                                    fontWeight: field?.isDefault && "bold",
                                  }}
                                >
                                  {data}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                </div>
              </>
              <>
                <div className={styles.branch_name}>{DonViSanXuat?.Ten}</div>
                <div>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className={styles.icon}
                  />
                  Địa chỉ cũ:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.DiaChiCu}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className={styles.icon}
                  />
                  Địa chỉ:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.DiaChi}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faPhone} className={styles.icon} />
                  Số điện thoại:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.SoDienThoai}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                  Email:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.Email}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faGlobe} className={styles.icon} />
                  Website:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    <a
                      className={styles.custom_a}
                      href={DonViSanXuat?.Website}
                      target="_blank"
                    >
                      {DonViSanXuat?.Website}
                    </a>
                  </span>
                </div>
              </>
            </>
          )}
        </div>
      </main>
    </>
  );
}
